import React from 'react';
import HeroCarousel from './../HeroCarousel';
import HomeSubSection from '../HomeSubSection';
// import MailingListModal from '../MailingListModal';
// import NoticeModal from '../NoticeModal';
const Home = () => {

    const carouselItems = [
        { src: require('../../images/chatters-dining.avif'), srcNarrow: require('../../images/chatters-dining-narrow.avif'), title: "RESTAURANT" },
        { src: require('../../images/full-savoury-buffet-slim.avif'), srcNarrow: require('../../images/full-savoury-buffet-narrow.avif'), title: "CATERING" }
    ];

    return (
        <div className="page-mailing-spacer" style={{ marginBottom: '40px' }}>
            <HeroCarousel
                items={carouselItems}
                tagline="Bringing people together through great food & service"
            />
            {/*<MailingListModal/>*/}
            {/* <NoticeModal /> */}
            <HomeSubSection />
        </div>
    );
};

export default Home;
